export const EREG_BLURBS = [
	'Uploading instrument...',
	'Reading instrument details...',
	'Extracting instrument details...',
	'Finalizing extraction...',
];

export const APS_BLURBS = [
	"Tracking down the buyers... they're probably comparing mortgage rates again.",
	'Finding the sellers... hopefully not on a beach vacation.',
	"Locating the property... GPS, don't fail us now!",
	'Scanning for key dates... time is money, after all!',
	'Detecting fine print... who even writes this small?',
	'Aligning all the stars... okay, just the property details.',
	'Polishing the results... shiny APS insights coming up!',
	'Calculating how many sleeps until closing…',
	"Checking if the other side's lawyer is 'fun' or 'fun to argue with'.",
	"Seeing if there's a comma in that purchase price (or two).",
	'Confirming the house is on planet Earth…',
	"Confirming there's a property involved… and not just vibes.",
	"Decoding another 'handwritten amendment'—brace yourself.",
	'Checking if this APS was drafted with a pen… or a crayon.',
	"Verifying that this isn't just a recycled agreement from a totally different deal.",
	'Running a sanity check on these closing conditions—wish us luck.',
	"Confirming the buyer isn't still 'thinking about it' after signing firm.",
	'Checking if the deposit is in trust—or floating in real estate limbo.',
	'Verifying if the purchase price makes sense, or if someone misread the decimal.',
	'Verifying the brokerage details—because spelling matters when wiring money.',
	'Checking if the agent sent the full agreement—or just the pages that benefit them.',
	"Checking if the closing date is 'firm' or just 'highly optimistic'.",
	"Decoding the agent's 'creative contract writing' again…",
	'Verifying that the buyer and seller are, in fact, two different people.',
	'Confirming if this deposit is real or just a polite promise.',
	"Detecting if this is a smooth closing or a 'hope you cleared your afternoon' situation.",
	"Closer: Because you shouldn't need a detective to read an APS.",
	'Detecting if this closing date is realistic… or a wish upon a star.',
	"Running the 'will the funds actually arrive on time' simulation.",
	'Checking if this agreement is airtight… or held together with good intentions.',
	"Checking if the other lawyer is 'easygoing' or 'emailing in all caps'.",
	"Scanning for agents who promised things that aren't in writing (classic).",
	'Verifying your client is buying a house—not just a really expensive parking spot.',
	"Confirming this closing date doesn't fall on a holiday, a weekend, or a full moon.",
	'Scanning for duplicate addresses—because buying the wrong house would be awkward.',
	"Checking if 'converted church' means cozy home… or zoning nightmare.",
	'Running a check to see if this deal is a steal… or someone is being robbed.',
	'Checking if this closing date was picked with a dartboard.',
	"Checking if we're dealing with a seasoned pro… or someone Googling 'real estate law' as we speak.",
	'Reading this APS faster than a real estate agent dodges your calls…',
	'Your docs are getting a digital glow-up—transformation in progress!',
	'Hippity Hoppity, where is the property?',
	'Ripping through APS text like a toddler with a magazine.',
	'Results inbound... should be ready before you finish humming the Jeopardy theme song!',
	'Our tech is busy persuading your files to behave—thanks for your patience!',
	"We're sweet-talking your documents into cooperation—just a moment!",
	'Channeling our inner legal wizard—abracadabra, matter details coming right up!',
	'Running a vibe check on the APS.',
	'Your APS is nearly done! Don’t worry—no lawyer has been harmed in the process… yet.',
	'"Oh wow, that\'s a lot of strikethrough!"',
	'"This is like a treasure hunt! But a lot more paperwork..."',
	'"Taking a nap... Just kidding — almost done!"',
	'Sorting through conveyancing chaos like a legal ninja—stand by for the verdict!',
	'Busy deciphering legal hieroglyphics—almost there!',
	'Our tech is busy persuading your paperwork to behave—just a moment!',
	'Relax—we’re faster than coffee brewing. ☕',
	'Cue the elevator music… Just kidding, we’re faster than that.',
	'Patience, grasshopper. Master-level data extraction in progress.',
	'Translating paperwork into pixels—because even docs deserve a makeover!',
	'Bribing the APS with digital coffee to spill its secrets—almost done!',
	'Scanning the APS. Because manually typing is so 20th century.',
	'Consulting the space time continuum to see if this deal will close on time.',
];

export const COMMISSION_STATEMENT_BLURBS = [
	'Retrieving commission details... no calculator was harmed in this process.',
	'Checking the sale price... hope the numbers are playing nice today!',
	'Verifying commission percentages... must be nice to be a realtor!',
	'Calculating commission payable... proof that enthusiasm pays... a lot!',
	'Applying HST... the gift that keeps on giving... to the government!',
	'Finalizing commission breakdown... making sure every cent adds up!',
	'Generating the commission statement... almost there, get ready for the big reveal!',
];

export const FIRE_INSURANCE_BLURBS = [
	'Checking if the policy is fireproof… or just proof of fire?',
	'Summoning the insurance gods… hold tight!',
	"Verifying the coverage—because smoke signals aren't enough!",
	'Scouring for fine print… and extinguishing any loopholes!',
	'Waiting for the AI to stop reading the policy like a suspense novel…',
	"Inspecting closely… because 'burn after reading' isn't an option!",
	'Checking if the policy covers AI-generated wait times…',
	'Verifying if this policy covers spontaneous combustion…',
	"Confirming coverage so your clients don't get burned later!",
	"Checking that the effective date isn't in some distant, post-apocalyptic future…",
	'Ensuring the policy actually starts before the deal closes—always a good idea!',
	'Expiry date confirmed—at least something in this transaction has a clear deadline!',
	"Verifying fire coverage—because 'trust me, it's insured' won't hold up in court!",
	'Making sure the mortgagee is happy—because we all know who really owns the house!',
	"Scanning for fine print—because 'guaranteed replacement' sometimes has an asterisk!",
	"Confirming the mortgagee's name—so the bank doesn't come knocking later!",
	"Checking that 'replacement cost' isn't just code for 'good luck with that'!",
	"Your client's house is covered—but let's double-check the 'guaranteed' part!",
	"Yes, the policy will expire someday—just making sure it's not next Tuesday!",
	'Verifying the insurance company actually intends to replace the house, not downgrade it!',
	"Scanning for any 'creative' interpretations of 'coverage'—because we've seen things…",
	"Checking that 'guaranteed replacement' isn't just a fancy way of saying 'maybe'!",
	"Policy confirmed—now let's hope your client never actually needs it!",
];
